import React from 'react'
import "./navbar.scss"

const Navbar = () => {
  return (
    <>
      <div className='navbar_main'>
        <div className='custom-container'>
          <div className='innner_navbar'>
            <img src="\assets\logo.svg" alt="" />
            <button>Pre-Launch</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Navbar
